import { ISelectCompanyDTO } from 'components/Layout/Header/ProfileDropdown/hooks';
import apiClient, { apiAuthClient } from 'services/api/apiService';
import { ICompanyLoginParams, ICreateNewAccountDTO } from 'types/User.types';

const BASE_URL = '/v1/users';

export const editUserData = async (
  firstName?: string,
  lastName?: string,
  currentPassword?: string,
  newPassword?: string
) => {
  const url = BASE_URL + `/me`;
  const body = {
    first_name: firstName,
    last_name: lastName,
    current_password: currentPassword,
    new_password: newPassword,
  };
  !firstName && delete body.first_name;
  !lastName && delete body.last_name;
  !currentPassword && delete body.current_password;
  !newPassword && delete body.new_password;

  const { data } = await apiClient.patch(url, body);

  return data.data;
};

export const selectCompany = async (dto: ISelectCompanyDTO): Promise<any> => {
  const url = `/v1/select`;
  const payload = {
    ...(dto?.companyId && {
      company_id: dto.companyId,
    }),
  };
  const { data } = await apiClient.post<any>(url, payload);
  return data.data;
};

export const createNewAccount = async (
  params: ICreateNewAccountDTO
): Promise<any> => {
  const { token, firstName, lastName, email, password } = params;
  const url = `${BASE_URL}/register`;
  const payload = {
    token,
    first_name: firstName,
    last_name: lastName,
    email,
    password,
  };
  const { data } = await apiAuthClient.post<any>(url, payload);
  return data.data;
};

export const companyLogin = async (
  params: ICompanyLoginParams
): Promise<any> => {
  const { email, password, token } = params;
  const url = `${BASE_URL}/exists`;
  const payload = {
    email,
    password,
    token,
  };
  const { data } = await apiAuthClient.post<any>(url, payload);
  return data.data;
};
